import {useQuery} from 'react-query';
import {getTakenLoanPaymentDetail} from './getTakenLoanPaymentDetail';

const useGetTakenLoanPaymentDetail = (loanRequestGuid?: string) => {
  const {data, isLoading} = useQuery({
    queryKey: ['get-not-paid-loan-details', loanRequestGuid],
    queryFn: () => getTakenLoanPaymentDetail(loanRequestGuid),
    enabled: !!loanRequestGuid,
  });

  return {data, isLoading};
};
export default useGetTakenLoanPaymentDetail;
